/**
 * What a test console run panel links to, worked out from the run's made numbers (headless; the panel renders it).
 *
 * The records a run made open on One's record pages (the object manifest's `hrefOf`), so they follow One's routing
 * rather than a path written here. The run's suppliers come from the API's run read, not from here.
 */
import type { ManifestIndex } from "./object-ui/manifest";
import { recordOfNumber } from "./object-ui/refs";

/** A number the run made that is a record's number, with the One page it opens. */
export interface MadeRecord {
  /** What the run called it (`order_no`, `purchase_order_no_1`). */
  key: string;
  /** The number (`ORD-C49202`). */
  value: string;
  /** "Order ORD-C49202": the object's label and the number. */
  label: string;
  /** The record's One page; null for a record whose object has no page here. */
  href: string | null;
}

/** The made values that are record numbers, in the order the run made them; other values (a person's id) are not. */
export function madeRecordsOf(
  index: ManifestIndex,
  created: Readonly<Record<string, string>>,
): MadeRecord[] {
  const records: MadeRecord[] = [];
  for (const [key, value] of Object.entries(created)) {
    const record = recordOfNumber(index, value);
    if (!record) continue;
    records.push({
      key,
      value,
      label: `${index.objectOf(record.object).label} ${value}`,
      href: index.hrefOf(record),
    });
  }
  return records;
}
